import {Ausbildung, IAusbildung} from './ausbildung.model';
import {CatalogAssignment} from './catalog-assignment.model';
import {Faehigkeit, IFaehigkeit} from './faehigkeit.model';
import {Personaldaten} from './personaldaten.model';
import {IProjekt, Projekt} from './projekt.model';
import {ISchulung, Schulung} from './schulung.model';
import {IWerdegang, Werdegang} from './werdegang.model';
import {IZertifikat, Zertifikat} from './zertifikat.model';
import {Note} from './notes.model';

export interface IBerater {
  id?: string;
  login?: string;
  vorname?: string;
  nachname?: string;
  email?: string;
  schulungen?: ISchulung[];
  werdegang?: IWerdegang[];
  ausbildung?: IAusbildung[];
  projekte?: IProjekt[];
  faehigkeiten?: IFaehigkeit[];
  personaldaten?: Personaldaten;
  zertifikate?: IZertifikat[];
  catalogAssignments?: CatalogAssignment[];
  notes?: Note;
  applicant?: boolean;
  freelancer?: boolean;
}

export class Berater implements IBerater {
  constructor(
    public id?: string,
    public login?: string,
    public vorname?: string,
    public nachname?: string,
    public email?: string,
    public schulungen?: ISchulung[],
    public werdegang?: IWerdegang[],
    public ausbildung?: IAusbildung[],
    public projekte?: IProjekt[],
    public faehigkeiten?: IFaehigkeit[],
    public personaldaten?: Personaldaten,
    public zertifikate?: IZertifikat[],
    public catalogAssignments?: CatalogAssignment[],
    public notes?: Note,
    public applicant?: boolean,
    public freelancer?: boolean
  ) {
  }

  static fromJson(json: IBerater) {
    const berater: Berater = new Berater();
    berater.id = json.id;
    berater.login = json.login;
    berater.vorname = json.vorname;
    berater.nachname = json.nachname;
    berater.email = json.email;
    berater.schulungen = [];
    berater.werdegang = [];
    berater.ausbildung = [];
    berater.projekte = [];
    berater.faehigkeiten = [];
    berater.personaldaten = Personaldaten.fromJson(json.personaldaten);
    berater.zertifikate = [];
    berater.catalogAssignments = [];
    if (json.schulungen) {
      json.schulungen.forEach((schulung) => {
        berater.schulungen.push(Schulung.fromJson(schulung));
      });
    }

    json.werdegang.forEach((werdegang) => {
      berater.werdegang.push(Werdegang.fromJson(werdegang));
    });
    if (json.ausbildung) {
      json.ausbildung.forEach((ausbildung) => {
        berater.ausbildung.push(Ausbildung.fromJson(ausbildung));
      });
    }
    if (json.projekte) {
      json.projekte.forEach((projekt) => {
        berater.projekte.push(Projekt.fromJson(projekt));
      });
    }
    if (json.faehigkeiten) {
      json.faehigkeiten.forEach((faehigkeit) => {
        berater.faehigkeiten.push(Faehigkeit.fromJson(faehigkeit));
      });
    }
    if (json.zertifikate) {
      json.zertifikate.forEach((zertifikat) => {
        berater.zertifikate.push(Zertifikat.fromJson(zertifikat));
      });
    }
    if (json.catalogAssignments) {
      json.catalogAssignments.forEach((assignment) => {
        berater.catalogAssignments.push(assignment);
      });
    }
    return berater;
  }
}
